<template>
  <div class="ota-upgrade" :class="isMobile ? 'pd-52' : 'pd-84'">
    <Header></Header>
    <Upgrade v-show="!isMobile && isSupport && !isMacOpera && !isWeChat"></Upgrade>
    <Error :isMac="isMac" v-if="!isMobile && (!isSupport || isMacOpera || isWeChat)"></Error>
    <Mobile v-if="isMobile"></Mobile>
  </div>
</template>

<style scoped lang="less">
.pd-52 {
  padding-top: 52px;
}

.pd-84 {
  padding-top: 84px;
}
</style>

<script>
import Header from "./components/header.vue";
import Mobile from "./mobile.vue";
import Error from "./error.vue";
import Upgrade from "./upgrade.vue";
import { reportData } from "../../serverice/api";
import getBrowserType from '../../utils/getBrowserType'

export default {
  components: {
    Mobile,
    Error,
    Upgrade,
    Header,
  },
  data() {
    return {
      isMobile: false,
      isSupport: true,
      isMacOpera:false,
      isMac:false,
      isWeChat: false
    };
  },
  created() {
    this.handleResize();
    this.getOS();
    this.getWeChat();

    if ("usb" in navigator) {
      this.isSupport = true;
    } else {
      this.isSupport = false;
    }
    window.visitTime = Date.now();
    // 用户进入页面时上报
    reportData({
      PageName: "page_ota",
      Browser_Agent: getBrowserType(),
    });
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    delete window.visitTime;
  },
  methods: {
    handleResize() {
      var html = document.documentElement;
      var hWidth = html.getBoundingClientRect().width;

      if (hWidth <= 950) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    
    getOS() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      console.log("userAgent", userAgent);

      // 检查是否是 Windows
      if (/windows/i.test(userAgent)) {
        console.log("Windows");
        this.isMacOpera = false;
        this.isMac = false;
        return;
      }

      // 检查是否是 Mac
      if (/macintosh|mac os x/i.test(userAgent)) {
        console.log("mac");
        this.isMac = true;
        let isOpera = userAgent.includes("Opera") || userAgent.includes("OPR");
        console.log("isOpera", isOpera);

        if (this.isMac && isOpera) {
          this.isMacOpera = true;
        } else {
          this.isMacOpera = false;
        }
      }
    },

    getWeChat() {
      if(/MicroMessenger/i.test(window.navigator.userAgent)) {
        this.isWeChat = true;
      } else {
        this.isWeChat = false;
      }
    },
  },
};
</script>
